import React, { useEffect, useState } from "react";
import { useStoreRoom, useStoreSystem } from "../../../store";
import { TireRackItemI } from "../../../store/types/store";
import EditPencil from "../../icons/EditPencil";
import * as THREE from "three";
import Remove from "../../icons/Remove/Remove";
import shallow from "zustand/shallow";
import { useCurrent } from "../../../hooks/useCurrent";

interface TireRackLabelProps {
    camera: any;
    canvasSize: any;
}

interface TireRackLabelBtnProps {
    position: {
        left: number;
        top: number;
    };
    onEdit(): void;
    onRemove(): void;
}

function useTireRackPosition(canvasSize: any, camera: any) {
    return (tireRack: TireRackItemI) => {
        const position = new THREE.Vector3(...tireRack.position);
        position.project(camera);

        const left = ((position.x + 1) * canvasSize?.width) / 2;
        const top = (-(position.y - 1) * canvasSize?.height) / 2;

        return { left, top };
    };
}

const TireRackLabelBtn: React.FC<TireRackLabelBtnProps> = (props) => {
    const { position, onEdit, onRemove } = props;

    return (
        <>
            <EditPencil
                onClick={onEdit}
                isChecked
                style={{
                    transform: `translate(${position.left - 40}px, ${position.top}px)`,
                }}
            />
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    borderRadius: 50,
                    alignItems: "center",
                    justifyContent: "space-between",
                    display: "flex",
                    backgroundColor: "#FFFFFF",
                    height: "29px",
                    padding: "1px",
                    border: "2px solid #ffffff",
                    boxShadow: "0px 4px 4px rgba(17, 17, 17, 0.36)",
                    transform: `translate(${position.left}px, ${position.top + 5}px)`,
                }}
            >
                <Remove onClick={onRemove} variant="primary" />
            </div>
        </>
    );
};

export const TireRacksLabels: React.FC<TireRackLabelProps> = ({ canvasSize, camera }) => {
    const { tireRacks, removeTireRack } = useStoreRoom(
        (state) => ({
            tireRacks: state.tireRacks,
            removeTireRack: state.removeTireRack,
        }),
        shallow
    );
    const { selectTireRack } = useStoreSystem((state) => ({
        setTireRackModal: state.setTireRackModal,
        selectTireRack: state.selectTireRack,
    }));
    const { currentEditItem } = useCurrent();
    const calcPosition = useTireRackPosition(canvasSize, camera);
    const [currentTireRack, setCurrentTireRack] = useState<TireRackItemI | undefined>();

    useStoreSystem((state) => state.labels, shallow);

    const handleEditTireRack = (tireRack: TireRackItemI) => () => {
        selectTireRack(tireRack.id);
    };

    const handleRemoveTireRack = (tireRack: TireRackItemI) => () => {
        removeTireRack(tireRack.id);
    };

    useEffect(() => {
        setCurrentTireRack(tireRacks.find((tireRack) => tireRack.id === currentEditItem.id));
    }, [currentEditItem, tireRacks]);

    return (
        <>
            {currentTireRack && (
                <TireRackLabelBtn
                    key={currentTireRack.id}
                    position={calcPosition(currentTireRack)}
                    onEdit={handleEditTireRack(currentTireRack)}
                    onRemove={handleRemoveTireRack(currentTireRack)}
                />
            )}
        </>
    );
};
